// extracted by mini-css-extract-plugin
export default {"header":"AccountForm_header__+bR4q"};